module.exports = __webpack_public_path__ + "static/media/a.da67966f.jpg";